import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  locale: "ar",
  direction: "rtl",
};

const html = document.documentElement;

const languageSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    toggleLanguage: (state) => {
      state.locale = state.locale === "en" ? "ar" : "en";
      state.direction = state.direction === "ltr" ? "rtl" : "ltr";
      html.setAttribute("lang", state.locale);
    },
  },
});

export const { toggleLanguage } = languageSlice.actions;

export default languageSlice.reducer;
